export default __webpack_public_path__ + "static/media/logo1.74852041.gif";